import i18next from 'i18next';
import React from 'react';

import { ContentContainer, ToggleRow } from './styledComponents';
import { ToggleSwitch } from '@commons/utils/styledLibraryComponents';
import Text from '@commons/Text';

import { getKey } from './utils';

export function PermissionsList({ tab, permissionsConfig, values, setValues }) {
  const filteredPermissions = permissionsConfig.filter(({ section }) => section === tab);

  return (
    <ContentContainer>
      {filteredPermissions.map((permission) => (
        <ToggleRow key={getKey(permission)}>
          <ToggleSwitch
            checked={values[getKey(permission)]}
            handleClick={() =>
              setValues((prev) => ({
                ...prev,
                [getKey(permission)]: !prev[getKey(permission)],
              }))
            }
            id={getKey(permission)}
          />
          <Text>{i18next.t(permission.label)}</Text>
        </ToggleRow>
      ))}
    </ContentContainer>
  );
}
